import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import BannerLayout from '../../../layouts/banner';
import AbbreviatedMillionNumberFormat from "../../../../../../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class SharePriceStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      marketValue: 0,
      shares: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, performanceFeedbacksGame } = this.props;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Share price fail").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      getRequest([
        `${process.env.REACT_APP_API_URL}team/report/metrics/?round_number=${activeRound}&team_id=${team_id}`
      ])
        .then(res => {
          const metrics = res.body;
          const currentRoundMetrics = metrics.find(i => i.round_number === activeRound);
          const prevRoundMetrics = metrics.find(i => i.round_number === activeRound - 1);

          const marketValue = currentRoundMetrics ? Number(currentRoundMetrics['Market Value'] || 0) : 0;
          let shares = currentRoundMetrics ? Number(currentRoundMetrics['Shares'] || 0) : 0;
          if (prevRoundMetrics) {
            const prevShares = prevRoundMetrics ? Number(prevRoundMetrics['Shares'] || 0) : 0;
            shares = (shares + prevShares) / 2;
          }

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            marketValue,
            shares,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      marketValue,
      shares,
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Share Price"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not generate enough revenues`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>In round 1 &#38; 2, business valuation is driven by revenues (i.e. <a href="https://www.investopedia.com/terms/p/price-to-salesratio.asp" target="_blank" rel='noreferrer'>price to sales ratio</a>). Therefore higher revenues should drive a higher valuation and hopefully a higher share price.</p>
            <p><strong>Note:</strong> In round 3 and beyond, business valuation will be driven by profits (i.e. price to earnings ratio).</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#4CC7D1" color="rgba(0, 27, 59, 0.94)">
              Share Price
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Business Value
              <span className='divider' />
              * Shares
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Revenues X 2.5
              <span className='divider' />
              * Shares
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={marketValue}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={shares}
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#D7F0F2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default SharePriceStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/share-price/step2.js